export const REQUEST_FUNERAL_LIST = 'REQUEST_FUNERAL_LIST';
export const REQUEST_CAMPAIGN_LIST = 'REQUEST_CAMPAIGN_LIST';
export const REQUEST_INVITATION_DETAIL = 'REQUEST_INVITATION_DETAIL';
export const REQUEST_CAMPAIGN_DETAIL = 'REQUEST_CAMPAIGN_DETAIL';
export const REQUEST_INVITATION_DETAIL_BY_COMID = 'REQUEST_INVITATION_DETAIL_BY_COMID';